export const API_BASE_URL = process.env.REACT_APP_API_URL
export const CUSTOMER_SITE_URL = process.env.REACT_APP_CUSTOMER_URL

const createApi = (module, action, method = "post") => ({
	method,
	url: `api/${module}/${action}`,
})

// Auth
export const ApiLogin = createApi('Auth', 'Login')
export const ApiCheckAuth = createApi('Auth', 'CheckAuth')
export const ApiRegister = createApi('Auth', 'Register')

// User
export const ApiUpdateUser = createApi('User', 'Update')
export const ApiDeleteUser = createApi('User', 'Delete')
export const ApiGetUser = createApi('User', 'GetById')
export const ApiGetUserList = createApi('User', 'GetList')
export const ApiCheckIsAdmin = createApi('User', 'CheckIsAdmin')

// Customer
export const ApiInsertCustomer = createApi('Customer', 'Create')
export const ApiUpdateCustomer = createApi('Customer', 'Update')
export const ApiDeleteCustomer = createApi('Customer', 'Delete')
export const ApiGetCustomer = createApi('Customer', 'GetById')
export const ApiGetCustomerList = createApi('Customer', 'GetList')

// Bank
export const ApiInsertBank = createApi('Bank', 'Create')
export const ApiUpdateBank = createApi('Bank', 'Update')
export const ApiDeleteBank = createApi('Bank', 'Delete')
export const ApiGetBank = createApi('Bank', 'GetById')
export const ApiGetBankList = createApi('Bank', 'GetList')

// EDC
export const ApiInsertEdc = createApi('Edc', 'Create')
export const ApiUpdateEdc = createApi('Edc', 'Update')
export const ApiDeleteEdc = createApi('Edc', 'Delete')
export const ApiGetEdc = createApi('Edc', 'GetById')
export const ApiGetEdcList = createApi('Edc', 'GetList')
export const ApiGetEdcBankList = createApi('Edc', 'GetEdcBankList')

// Card Vendor
export const ApiInsertCardVendor = createApi('CardVendor', 'Create')
export const ApiUpdateCardVendor = createApi('CardVendor', 'Update')
export const ApiDeleteCardVendor = createApi('CardVendor', 'Delete')
export const ApiGetCardVendor = createApi('CardVendor', 'GetById')
export const ApiGetCardVendorList = createApi('CardVendor', 'GetList')

// Customer Card
export const ApiInsertCustomerCard = createApi('CustomerCard', 'Create')
export const ApiUpdateCustomerCard = createApi('CustomerCard', 'Update')
export const ApiDeleteCustomerCard = createApi('CustomerCard', 'Delete')
export const ApiGetCustomerCard = createApi('CustomerCard', 'GetById')
export const ApiGetCustomerCardList = createApi('CustomerCard', 'GetList')
export const ApiGetCustomerCardListByCustomerId = createApi('CustomerCard', 'GetByCustomerId')

// Transaction
export const ApiInsertTransaction = createApi('Transaction', 'Create')
export const ApiUpdateTransaction = createApi('Transaction', 'Update')
export const ApiDeleteTransaction = createApi('Transaction', 'Delete')
export const ApiGetTransaction = createApi('Transaction', 'GetById')
export const ApiGetTransactionList = createApi('Transaction', 'GetList')
export const ApiGetTransactionCustomerCard = createApi('Transaction', 'GetTransactionCustomerCard')
export const ApiGetTransactionReportEdc = createApi('Transaction', 'GetTransactionReportEdc')
export const ApiGetTransactionStatistic = createApi('Transaction', 'GetTransactionStatistic')
export const ApiGetCustomerRankStatistic = createApi('Transaction', 'GetCustomerRankStatistic')
export const ApiGetDailyTransactionStatistic = createApi('Transaction', 'GetDailyTransactionStatistic')
export const ApiGetCustomerPaymentList = createApi('Transaction', 'GetCustomerPaymentList')

// Daily Transaction
export const ApiGetDailyTransaction = createApi('DailyTransaction', 'GetList')

// Payment Received
export const ApiGetPaymentReceived = createApi('PaymentReceived', 'GetList')
export const ApiUpdatePaymentReceived = createApi('PaymentReceived', 'Update')

// Reseller
export const ApiCreateReseller = createApi('Reseller', 'Create')
export const ApiDeleteReseller = createApi('Reseller', 'Delete')
export const ApiGetResellerList = createApi('Reseller', 'GetList')

// EDC Location
export const ApiUpdateEdcLocation = createApi('EdcLocation', 'Update')
export const ApiGetEdcLocation = createApi('EdcLocation', 'GetList')

// Beneficiary Account
export const ApiInsertBeneficiaryAccount = createApi('BeneficiaryAccount', 'Create')
export const ApiUpdateBeneficiaryAccount = createApi('BeneficiaryAccount', 'Update')
export const ApiDeleteBeneficiaryAccount = createApi('BeneficiaryAccount', 'Delete')
export const ApiGetBeneficiaryAccount = createApi('BeneficiaryAccount', 'GetById')
export const ApiGetBeneficiaryAccountList = createApi('BeneficiaryAccount', 'GetList')

// Customer Exeption
export const ApiInsertCustomerExeption = createApi('CustomerExeption', 'Create')
export const ApiDeleteCustomerExeption = createApi('CustomerExeption', 'Delete')
export const ApiGetCustomerExeptionList = createApi('CustomerExeption', 'GetList')

// Location
export const ApiInsertLocation = createApi('Location', 'Insert')
export const ApiUpdateLocation = createApi('Location', 'Update')
export const ApiDeleteLocation = createApi('Location', 'Delete')
export const ApiGetLocation = createApi('Location', 'GetById')
export const ApiGetLocationList = createApi('Location', 'GetList')

// User Location Access
export const ApiInsertUserLocationAccess = createApi('UserLocation', 'Insert')
export const ApiDeleteUserLocationAccess = createApi('UserLocation', 'Delete')
export const ApiGetUserLocationByUserId = createApi('UserLocation', 'GetUserLocationByUserId')
export const ApiGetUserLocationList = createApi('UserLocation', 'GetLocationList')

// Common
export const ApiGetCommonByKey = createApi('Common', 'GetByKey')

// Transfer Source
export const ApiGetTransferSourceList = createApi('TransferSource', 'GetList')
export const ApiGetTransferSourceById = createApi('TransferSource', 'GetById')
export const ApiInsertTransferSource = createApi('TransferSource', 'Create')
export const ApiUpdateTransferSource = createApi('TransferSource', 'Update')
export const ApiDeleteTransferSource = createApi('TransferSource', 'Delete')

// Transaction
export const ApiProceedPayment = createApi('Transaction', 'ProceedPayment')
export const ApiGetCustomerPaymentSummary = createApi('Transaction', 'GetCustomerPaymentSummary')
export const ApiGetCustomerPaymentById = createApi('Transaction', 'GetCustomerPaymentById')
export const ApiUpdateCustomerPayment = createApi('Transaction', 'UpdateCustomerPayment')

// Cash In
export const ApiCreateCashIn = createApi('CashIn', 'Create')
export const ApiGetCashInList = createApi('CashIn', 'GetList')
export const ApiGetCashInById = createApi('CashIn', 'GetById')
export const ApiUpdateCashIn = createApi('CashIn', 'Update')
export const ApiDeleteCashIn = createApi('CashIn', 'Delete')

// Transfer PL
export const ApiCreateTransferPL = createApi('TransferPL', 'Create')
export const ApiGetTransferPLList = createApi('TransferPL', 'GetList')
export const ApiGetTransferPLById = createApi('TransferPL', 'GetById')
export const ApiUpdateTransferPL = createApi('TransferPL', 'Update')
export const ApiDeleteTransferPL = createApi('TransferPL', 'Delete')

// Dashboard
export const ApiGetDashboardInfo = createApi('Dashboard', 'GetInfo')

// Settlement
export const ApiInsertSettlement = createApi('Settlement', 'Create')
export const ApiUpdateSettlement = createApi('Settlement', 'Update')
export const ApiDeleteSettlement = createApi('Settlement', 'Delete')
export const ApiGetSettlementById = createApi('Settlement', 'GetById')
export const ApiGetSettlementList = createApi('Settlement', 'GetList')
export const ApiPaySettlement = createApi('Settlement', 'PaySettlement')
export const ApiSettlementTransaction = createApi('Settlement', 'SettlementTransaction')

// Bank Balance
export const ApiGetBankBalanceList = createApi('BankBalance', 'GetList')
export const ApiUpdateBankBalance = createApi('BankBalance', 'Update')

// Expense
export const ApiCreateExpense = createApi('Expense', 'Create')
export const ApiUpdateExpense = createApi('Expense', 'Update')
export const ApiDeleteExpense = createApi('Expense', 'Delete')
export const ApiGetExpenseList = createApi('Expense', 'GetList')
export const ApiGetExpenseById = createApi('Expense', 'GetById')